import { Grid, Paper, Typography } from '@material-ui/core';
import { RecommendedActions } from './RecommendedActions';
import { useStyles } from '../../../styles';
import { QeScoreAnalysisResults } from '../../../interfaces';

interface AnalysisResultsProps {
  qeScoreAnalysisResults: QeScoreAnalysisResults | null;
}

export function AnalysisResults({
  qeScoreAnalysisResults,
}: AnalysisResultsProps) {
  const classes = useStyles();
  const recommendedActions = qeScoreAnalysisResults?.actionItems ?? [];

  const projectedScore =
    qeScoreAnalysisResults?.reportMetadata?.improvementPotential ?? 0;

  return (
    <>
      <Grid container spacing={3} className={classes.indexAnalysisSummaryGrid}>
        <Grid item xs={12} sm={6}>
          <Paper
            variant="outlined"
            className={classes.indexAnalysisSummaryPaper}
          >
            <Typography
              variant="subtitle1"
              className={classes.indexAnalysisSummaryTitle}
            >
              Total Actions Identified
            </Typography>
            <Typography
              variant="h4"
              className={classes.indexAnalysisSummaryValue}
            >
              {qeScoreAnalysisResults?.totalWorkItems || 0}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper
            variant="outlined"
            className={classes.indexAnalysisSummaryPaper}
          >
            <Typography
              variant="subtitle1"
              className={classes.indexAnalysisSummaryTitle}
            >
              Expected increase in Score
            </Typography>
            <Typography
              variant="h4"
              className={classes.indexAnalysisSummaryValue}
            >
              {projectedScore}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <RecommendedActions actions={recommendedActions} />
    </>
  );
}
